import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const SettingsContext = createContext({ settings: {}, refresh: () => {} });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});

  const refresh = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data || {});
    } catch {
      /* silent — settings will fall back to defaults */
    }
  };

  useEffect(() => { refresh(); }, []);
  return <SettingsContext.Provider value={{ settings, refresh }}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);

export const whatsappHref = (number, msg = "") => {
  const n = String(number || "+905335089324").replace(/[^\d]/g, "");
  return `https://wa.me/${n}${msg ? `?text=${encodeURIComponent(msg)}` : ""}`;
};

export const formatPrice = (n, currency = "TL") => {
  const v = Number(n || 0);
  return `${v.toLocaleString("tr-TR", { maximumFractionDigits: 0 })} ${currency}`;
};
